const VoucherCampaignGroup = {
  SPIAllowance: "spi-allowance",
  SPIAllocation: "spi-allocation",
  SPIObTravel: "spi-ob-travel",
  Others: "others",
};

export default VoucherCampaignGroup;
